var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultipoint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44984 7.59012C5.75324 7.59012 6.80984 6.53351 6.80984 5.23012C6.80984 3.92673 5.75324 2.87012 4.44984 2.87012C3.14645 2.87012 2.08984 3.92673 2.08984 5.23012C2.08984 6.53351 3.14645 7.59012 4.44984 7.59012Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1198 7.59012C13.4232 7.59012 14.4798 6.53351 14.4798 5.23012C14.4798 3.92673 13.4232 2.87012 12.1198 2.87012C10.8164 2.87012 9.75977 3.92673 9.75977 5.23012C9.75977 6.53351 10.8164 7.59012 12.1198 7.59012Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7799 7.59012C21.0833 7.59012 22.1399 6.53351 22.1399 5.23012C22.1399 3.92673 21.0833 2.87012 19.7799 2.87012C18.4765 2.87012 17.4199 3.92673 17.4199 5.23012C17.4199 6.53351 18.4765 7.59012 19.7799 7.59012Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44984 14.3601C5.75324 14.3601 6.80984 13.3035 6.80984 12.0001C6.80984 10.6967 5.75324 9.64014 4.44984 9.64014C3.14645 9.64014 2.08984 10.6967 2.08984 12.0001C2.08984 13.3035 3.14645 14.3601 4.44984 14.3601Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1198 14.3601C13.4232 14.3601 14.4798 13.3035 14.4798 12.0001C14.4798 10.6967 13.4232 9.64014 12.1198 9.64014C10.8164 9.64014 9.75977 10.6967 9.75977 12.0001C9.75977 13.3035 10.8164 14.3601 12.1198 14.3601Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7799 14.3601C21.0833 14.3601 22.1399 13.3035 22.1399 12.0001C22.1399 10.6967 21.0833 9.64014 19.7799 9.64014C18.4765 9.64014 17.4199 10.6967 17.4199 12.0001C17.4199 13.3035 18.4765 14.3601 19.7799 14.3601Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22035 21.1302C5.52374 21.1302 6.58035 20.0735 6.58035 18.7702C6.58035 17.4668 5.52374 16.4102 4.22035 16.4102C2.91696 16.4102 1.86035 17.4668 1.86035 18.7702C1.86035 20.0735 2.91696 21.1302 4.22035 21.1302Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8795 21.1302C13.1829 21.1302 14.2395 20.0735 14.2395 18.7702C14.2395 17.4668 13.1829 16.4102 11.8795 16.4102C10.5761 16.4102 9.51953 17.4668 9.51953 18.7702C9.51953 20.0735 10.5761 21.1302 11.8795 21.1302Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5504 21.1302C20.8538 21.1302 21.9104 20.0735 21.9104 18.7702C21.9104 17.4668 20.8538 16.4102 19.5504 16.4102C18.247 16.4102 17.1904 17.4668 17.1904 18.7702C17.1904 20.0735 18.247 21.1302 19.5504 21.1302Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21973 5.22998H19.5497V12H4.44973V18.77H19.5497",
    stroke: "black",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipoint);
export default __webpack_public_path__ + "static/media/multipoint.4f955fb5979914be9f74f7ed36f5f926.svg";
export { ForwardRef as ReactComponent };